import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: 'table[tr3MatTableStatic]',
  host: {
    'class': 'mat-table tr3-mat-table-static',
    '[class.mat-table-fixed-layout]': 'fixedLayout',
    '[attr.dense]': 'dense || undefined',
  },
})
export class MatTableStaticDirective {
  constructor(private _elementRef: ElementRef<HTMLTableElement>) {}

  @Input()
  get fixedLayout(): boolean {
    return this._fixedLayout;
  }
  set fixedLayout(v: boolean) {
    this._fixedLayout = coerceBooleanProperty(v);
  }
  private _fixedLayout = false;

  @Input()
  get dense(): boolean {
    return this._dense;
  }
  set dense(v: boolean) {
    this._dense = coerceBooleanProperty(v);
  }
  private _dense = false;

  private setClass(selector: string, className: string) {
    this._elementRef.nativeElement.querySelectorAll(selector).forEach((e) => e.classList.add(className));
  }

  ngAfterContentChecked(): void {
    this.setClass('thead tr:not(.mat-header-row)', 'mat-header-row');
    this.setClass('tfoot tr:not(.mat-footer-row)', 'mat-footer-row');
    this.setClass('tr:not(.mat-header-row):not(.mat-footer-row):not(.mat-row)', 'mat-row');
    this.setClass('th:not(.mat-header-cell)', 'mat-header-cell');
    this.setClass('tfoot td:not(.mat-footer-cell)', 'mat-footer-cell');
    this.setClass('td:not(.mat-footer-cell):not(.mat-cell)', 'mat-cell');
  }
}
